import React from 'react';

import {addSavedRoute, removeSavedRoute} from "../../actions";
import OImg from "../OImg";
import {connect} from "react-redux";
import {compose} from 'redux';
import SplitComponent from "./SplitComponent";
import {withTranslation} from "react-i18next";

const ApproachComponent = ({ t, approachImg, route}) => {
    let topContent = null, bottomContent = null;

    const groupRoute = route?.groupRoute;
    const groupRouteHasCoordsGps = groupRoute?.latitudeParking && groupRoute?.longitudeParking
    const routeHasCoordGps = route?.longitudeParking && route?.latitudeParking;

    if (routeHasCoordGps || groupRouteHasCoordsGps || groupRoute?.approach || route?.approach || route.approachTimeLabel) {
        bottomContent = <div className='px-2 wysiwyg'>
            <h3>{t('approachScreen.title')}</h3>
            {groupRouteHasCoordsGps && <p className="mb-2">
                <> {t('approachScreen.coordsParking')}</>
                <strong className="text-secondary">{groupRoute.latitudeParking} {groupRoute.longitudeParking}</strong>
            </p>}
            {routeHasCoordGps && <p className="mb-2">
                <> {t('approachScreen.coordsParking')}</>
                <strong className="text-secondary">{route.latitudeParking} {route.longitudeParking}</strong>
            </p>}
            {route?.approachTimeLabel && <p className="mb-2">
                {t('approachScreen.approachTimeLabel')}
                <strong className="text-secondary" dangerouslySetInnerHTML={{__html: route.approachTimeLabel}}/>
            </p>}
            {groupRoute?.approach && <p dangerouslySetInnerHTML={{__html: groupRoute.approach}}/>}
            {route?.approach && <p dangerouslySetInnerHTML={{__html: route.approach}}/>}
        </div>;
    }

    if (approachImg) {
        topContent = <div className="w-100 h-100 img-container">
            <OImg
                src={approachImg}
                className={'mb-3'}
                fullscreen={bottomContent === null}
                withZoom={true}
            />
        </div>
    }

    return (
        <SplitComponent
            topContent={topContent}
            bottomContent={bottomContent}
        />
    );
}


const mapDispatchToProps = dispatch => {
    return {
        addSavedRoute: (route) => {
            dispatch(addSavedRoute(route))
        },
        removeSavedRoute: (route) => {
            dispatch(removeSavedRoute(route))
        },
    }
}


const mapStateToProps = (state) => {
    return {
        savedRoutes: state.navbar.savedRoute
    }
}

export default
compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(ApproachComponent);